import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { Query as RootQuery } from 'graphql/models/generated';

export const ORGANIZATION_QUERY = gql`
  query organization($id: String!) {
    organization(where: { id: $id }) {
      id
      defaultConditions {
        id
        vat
        surcharge
        discount
        type
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class OrganizationQuery extends Query<RootQuery> {
  document = ORGANIZATION_QUERY;
}
